"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

const YANDEX_METRIKA_ID = 112336017;

const YANDEX_METRIKA_SNIPPET = `(function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${YANDEX_METRIKA_ID}', 'ym');

    ym(${YANDEX_METRIKA_ID}, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});`;

type YmFn = (id: number, method: string, url: string) => void;

/** SSR: executable in <head>. Client: data block — no re-init. SPA: hit on route. */
export function YandexMetrikaScript() {
  const pathname = usePathname();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    const ym = (window as Window & { ym?: YmFn }).ym;
    ym?.(YANDEX_METRIKA_ID, "hit", window.location.href);
  }, [pathname]);

  return (
    <script
      type={typeof window === "undefined" ? "text/javascript" : "text/plain"}
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: YANDEX_METRIKA_SNIPPET }}
    />
  );
}

export function YandexMetrikaNoscript() {
  return (
    <noscript>
      <div>
        <img
          src={`https://mc.yandex.ru/watch/${YANDEX_METRIKA_ID}`}
          style={{ position: "absolute", left: "-9999px" }}
          alt=""
        />
      </div>
    </noscript>
  );
}
